import { getPageSettings } from "../util/pageSettings";

const whitelistedAPIs: string[] = ["techavailability", "calculateestimate", "booking", "contactus", "quote"];

// Exported for testing purposes
export const templateWhitelisting: string[] = [];

interface AxiosRequestConfig {
    url: string;
}

export function isWhitelistedAPI(config: AxiosRequestConfig): boolean {
    // Input validation
    if (!config || !config.url) {
        return false;
    }

    const url = config.url;

    // Step 1: Check template whitelist (if configured)
    if (templateWhitelisting.length > 0) {
        const pageTemplate = getPageSettings('pagetemplate');
        if (pageTemplate) {
            const template = removeEmptySpacesAndConvertToLowerCase(pageTemplate);
            const cleanedTemplateWhitelist = templateWhitelisting.map((item) =>
                removeEmptySpacesAndConvertToLowerCase(item)
            );
            // If template whitelist exists, ONLY allow if template matches
            return cleanedTemplateWhitelist.includes(template);
        }
    }

    // Step 2: Validate URL against whitelist (strict matching)
    const cleanedUrl = removeEmptySpacesAndConvertToLowerCase(url);
    return whitelistedAPIs.some(api => {
        // Use word boundary matching to prevent substring attacks
        // Match: /techavailability, /techavailability/, /techavailability?
        // Reject: /faketechavailability
        const regex = new RegExp(`[/\\?&]${api}([/\\?&#]|$)`, 'i');
        return regex.exec(cleanedUrl) !== null;
    });
}

function removeEmptySpacesAndConvertToLowerCase(str: string | null | undefined): string {
    if(!str){
        return '';
    }
    return str.toLowerCase().replace(/\s+/g, '');
}